enum OptionalFeature {
  None = '',
  Simulcast = 'simulcast'
}

export default OptionalFeature;
